export const AUTH_TOKENS = 'authTokens'
export const CLIENT_ID = 'clientId'
export const SEAT_ID = 'seatId'
export const MFA_TOKENS = 'mfaTokens'
export const CONTEXT_TOKEN = 'contextTokens'
